import React from 'react';

interface ForecastMeasurementSummaryProps {
  text: string;
  className?: string;
}

const ForecastMeasurementSummary: React.FC<ForecastMeasurementSummaryProps> = ({
  text,
  className,
}) => {
  return (
    <div
      className={`inline-flex max-h-fit max-w-fit items-center rounded-[45px] border-[2px] px-[18px] ${className}`}
    >
      <div className={`mr-[10px] h-[6px] w-[6px]`}></div>
      <p className="noto-14-medium py-2 leading-5 text-dark-3">{text}</p>
    </div>
  );
};

export default ForecastMeasurementSummary;
